function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Fill-and-stroke",
  className: "cls-1",
  d: "M12.216,10.5H10.465v1.75A1.749,1.749,0,0,1,8.716,14h-7a1.75,1.75,0,0,1-1.75-1.75v-7A1.749,1.749,0,0,1,1.716,3.5H3.465V1.75A1.75,1.75,0,0,1,5.216,0h7a1.75,1.75,0,0,1,1.75,1.75v7A1.75,1.75,0,0,1,12.216,10.5Zm0-8.75h-7V3.5h3.5a1.749,1.749,0,0,1,1.749,1.75v3.5h1.751Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/fill-and-stroke.5afe55ed.svg";
export { SvgComponent as ReactComponent };